<template>
    <div>

        <config-main-title>
            Prioridade de Tarefas
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Prioridade
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Prioridade identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Prioridade'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.st_prioridade }}
                        </a>

                        <span class="badge badge-secondary ml-2">#{{  dado.id_prioridade }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <span v-else>
                            <span class="badge" :class="'badge-' + dado.st_cor">
                                {{ dado.st_sigla ? dado.st_sigla : '-' }} 
                            </span>
                        </span>
                    </span>
                </li>
            </div>

            <pre v-if="false">{{ outros_acessos }}</pre>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_prioridade ) ? '' : 'Novo' }}
                            Prioridade
                            <span v-if="item && item.id_prioridade">
                                #{{ item.id_prioridade }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Nome do status..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_prioridade" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Sigla..."
                                    :validate="validate"
                                    v-model="item.st_sigla" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Cor"
                                    type="select"
                                    :validate="validate"
                                    :optionsList="[
                                        { id: 'primary', search: 'Azul' },
                                        { id: 'success', search: 'Verde' },
                                        { id: 'danger', search: 'Vermelho' },
                                        { id: 'dark', search: 'Preto' },
                                        { id: 'secondary', search: 'Cinza' },
                                        { id: 'warning', search: 'Amarelo' },
                                        { id: 'info', search: 'Ciano' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_cor" />
                            </div>
                        </div>

                        <div class="d-flex flex-column mt-1 mb-3" v-if="item.st_cor">
                            <span class="badge" :class="'badge-' + item.st_cor">
                                &nbsp;
                            </span>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="SLA de Primeira Resposta"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_sla_primeira_resposta">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text">h</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="SLA de Solução"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_sla_solucao">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text">h</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="tarefaPrioridade" :id="item.id_prioridade" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_prioridade ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            outros_acessos: [],
            is_reembolso: false, 
            is_infusao: false, 
        }
    },

    props: ['teste'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        EdicaoAcessos
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        tem_acesso: function () { 
            return 'tarefa_prioridade' == 'atendimento'
                || 'tarefa_prioridade' == 'receita';
        },

    },

    methods: { 
        acessos(item, outro) { 
          this.$refs.acessos.abrir(
              'App\\azure\\tarefaPrioridade', 
              item.id_prioridade, 
              _.get(outro, 'search'), 
              _.get(outro, 'id')
            );
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_prioridade: null, 
                st_prioridade: "", 
                st_cor: "primary",
                fl_ativo: true, 
                model_type: 'App\\azure\\tarefaPrioridade'
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'tarefa_prioridade',
                func: 'index',
                parms: { 
                    model: 'tarefa_prioridade', 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;

            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'tarefa_prioridade',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'tarefa_prioridade',
                dados: item,
            });

        },
    },

    mounted () { 
        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: "Prioridade da Tarefa" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.load();

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>